/* eslint-disable no-console */
import { DatePicker, Popover } from "antd";
import React, { useState } from "react";
import dayjs from "dayjs";
import { TIME_FILTER } from "../constants";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";
import TickIcon from "../../../Common/Svgs/TickIcon";

const options = [
  {
    id: TIME_FILTER.TODAY,
    value: "today",
  },
  {
    id: TIME_FILTER.YESTERDAY,
    value: "yesterday",
  },
  {
    id: TIME_FILTER.THIS_WEEK,
    value: "this week",
  },
  {
    id: TIME_FILTER.LAST_WEEK,
    value: "last week",
  },
  {
    id: TIME_FILTER.THIS_MONTH,
    value: "this month",
  },
  {
    id: TIME_FILTER.LAST_MONTH,
    value: "last month",
  },
  // {
  //   id: TIME_FILTER.CUSTOM,
  //   value: "custom",
  // },
];

const LABEL_CLASS = {
  kpi: "text-base h-[26px] text-black",
  "energy-distribution":
    "bg-yellow text-xs h-[42px] py-[11px] px-4 rounded-md max-w-max text-black",
  "charging-history":
    "bg-background-white hover:bg-background text-xs h-[42px] py-[11px] px-4 rounded-md max-w-max text-dark-gray",
};

const CHEVRON_CLASS = {
  kpi: "w-5 h-5 stroke-black",
  "energy-distribution": "w-4 h-4 stroke-black",
  "charging-history": "w-4 h-4 stroke-dark-gray",
};

const TimeFilter = ({ filter, setFilter, variant = "kpi" }) => {
  const [open, setOpen] = useState(false);
  const [dateRangeOpen, setDateRangeOpen] = useState(false);
  const [datePanelRangeOpen, setDatePanelRangeOpen] = useState(false);

  console.log(dateRangeOpen, datePanelRangeOpen);

  const onDateRangeSelect = (e) => {
    if (e.length < 2) return;

    setFilter((prev) => ({
      ...prev,
      custom: e,
    }));

    setDatePanelRangeOpen(false);
    setDateRangeOpen(false);
    setOpen(false);
  };

  const getBody = (option, selected) => {
    if (option.id === TIME_FILTER.CUSTOM && selected) {
      return (
        <div className="px-3">
          {/* close the date picker if no values selected */}
          <div
            className="fixed top-0 bottom-0 right-0 left-0 w-full h-full bg-transparent"
            onClick={() => {
              setOpen(false);
              setDateRangeOpen(false);
              setDatePanelRangeOpen(false);
              setFilter({
                id: 1,
                value: "today",
                custom: [],
              });
            }}
          />

          <DatePicker.RangePicker
            // open={datePanelRangeOpen}
            format="DD, MMM YYYY"
            value={filter?.custom?.length ? filter.custom : null}
            placement="bottom"
            separator="-"
            allowClear={false}
            className="h-[30px] max-w-[245px] z-10 font-poppins"
            inputReadOnly
            onChange={onDateRangeSelect}
            onOpenChange={(state) => setDatePanelRangeOpen(state)}
            disabledDate={(current) => current.isAfter(dayjs(), "day")}
          />
        </div>
      );
    }

    return (
      <button
        type="button"
        key={option.id}
        className="w-full py-2 px-3 capitalize group hover:bg-background max-h-20"
        onClick={() => {
          setFilter({ ...option, custom: [] });

          if (option.id === TIME_FILTER.CUSTOM) {
            setDateRangeOpen(true);
          } else {
            setOpen(false);
          }
        }}
      >
        <div className="flex items-center justify-between">
          <p
            className={`font-aileron text-xs font-semibold text-left capitalize
              ${
                selected
                  ? "text-black"
                  : "text-dark-gray group-hover:text-black"
              }
             `}
          >
            {option.value}
          </p>

          {selected ? (
            <div className="flex items-center gap-x-2">
              <TickIcon size={16} strokeWidth={2} className="text-primary" />
            </div>
          ) : null}
        </div>
      </button>
    );
  };

  return (
    <div className="relative">
      <Popover
        trigger="click"
        placement="bottomLeft"
        open={open}
        arrow={false}
        onOpenChange={(state) => setOpen(state)}
        content={
          <div
            className="bg-background-white rounded-md py-1"
            style={{ width: "252px" }}
          >
            {options.map((option) => {
              const selected = filter?.id === option?.id;
              return <div key={option.id}>{getBody(option, selected)}</div>;
            })}
          </div>
        }
      >
        <div
          role="button"
          className={`flex items-center gap-x-2 ${LABEL_CLASS[variant]}`}
        >
          {variant === "kpi" && (
            <img
              src="/assets/icons/calendar.svg"
              className="w-5 h-5"
              alt="calendar"
            />
          )}
          <p className="font-poppins font-medium capitalize whitespace-nowrap">
            {filter?.value === "custom"
              ? `${dayjs(filter.custom[0]).format("DD MMM, YYYY")} - ${dayjs(
                  filter.custom[1],
                ).format("DD MMM, YYYY")}`
              : filter?.value}
          </p>

          <ChevronIcon
            strokeWidth="1"
            className={`transform transition-all duration-200 
              ${CHEVRON_CLASS[variant]}
              ${open ? "-rotate-90" : "rotate-90"}`}
          />
        </div>
      </Popover>
    </div>
  );
};

export default TimeFilter;
